import dayjs from 'dayjs';
import type { AssetDetails } from 'modules/queries/asset/useDetails';

/**
 * Whether the asset has a cancellation dated today or later. A date in the past
 * belongs to a cancellation that has already run its course.
 */
const getIsCancellationScheduled = (
	scheduledCancellationDate: AssetDetails['scheduledCancellationDate'],
) => {
	const cancellationDate = scheduledCancellationDate?.DateTime;

	return cancellationDate
		? dayjs(cancellationDate).isSameOrAfter(dayjs(), 'day')
		: false;
};

export default getIsCancellationScheduled;
